module.exports = __webpack_public_path__ + "static/media/bottomRightDarkBubbles.a2c73f74.png";